import { render } from "./bottom-nav.vue?vue&type=template&id=22039cc8&scoped=true"
import script from "./bottom-nav.vue?vue&type=script&lang=js"
export * from "./bottom-nav.vue?vue&type=script&lang=js"

import "./bottom-nav.vue?vue&type=style&index=0&id=22039cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22039cc8"]])

export default __exports__